import SlidingPanel from "@components/sliders/SlidingPanel";
import Switcher from "@components/switcher/Switcher";
import { userManagementApis } from "@services/apis/UserManagement";
import NotificationSettingsTypes, {
  GetNotificationsSettingsResponse,
} from "@services/models/UserManagement/get-notification-settings";
import React, { useEffect, useState } from "react";
import NotificationsAccount from "./Account";
import NotificationsBusiness from "./Business";
import NotificationsPersonal from "./Personal";

interface NotificationSettingsSliderProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (success: boolean) => void;
  userId: number;
  accountType: string;
}

const NotificationSettingsSlider: React.FC<NotificationSettingsSliderProps> = ({
  isOpen,
  onClose,
  onConfirm,
  userId,
  accountType,
}) => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [settings, setSettings] =
    useState<GetNotificationsSettingsResponse | null>(null);

  const fetchSecuritySettings = async () => {
    setLoading(true);
    try {
      const response = await userManagementApis.getNotificationSettings(userId);
      setSettings(response);
      setLoading(false);
    } catch (error: any) {
      setError(
        error?.response?.data?.msg || "Failed to fetch notification settings",
      );
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) fetchSecuritySettings();
  }, [isOpen, userId]);

  if (error) {
    return (
      <SlidingPanel isOpen={isOpen} onClose={onClose}>
        <div className="p-4 text-red-500">{error}</div>
      </SlidingPanel>
    );
  }

  const tabs =
    accountType === "institutional" || accountType === "small_merchant"
      ? [
          {
            label: NotificationSettingsTypes.personal.toUpperCase(),
            component: (
              <NotificationsPersonal
                userId={userId}
                settingsData={settings?.data.filter(
                  (setting) =>
                    setting.notificationType ===
                    NotificationSettingsTypes.personal,
                )}
                loading={loading}
                setPersonalSettings={setSettings}
              />
            ),
          },
          {
            label: NotificationSettingsTypes.business.toUpperCase(),
            component: (
              <NotificationsBusiness
                userId={userId}
                settingsData={settings?.data.filter(
                  (setting) =>
                    setting.notificationType ===
                    NotificationSettingsTypes.business,
                )}
                loading={loading}
                setPersonalSettings={setSettings}
              />
            ),
          },
          {
            label: NotificationSettingsTypes.account.toUpperCase(),
            component: (
              <NotificationsAccount
                userId={userId}
                settingsData={settings?.data.filter(
                  (setting) =>
                    setting.notificationType ===
                    NotificationSettingsTypes.account,
                )}
                loading={loading}
                setPersonalSettings={setSettings}
              />
            ),
          },
        ]
      : [
          {
            label: NotificationSettingsTypes.personal.toUpperCase(),
            component: (
              <NotificationsPersonal
                userId={userId}
                settingsData={settings?.data.filter(
                  (setting) =>
                    setting.notificationType ===
                    NotificationSettingsTypes.personal,
                )}
                loading={loading}
                setPersonalSettings={setSettings}
              />
            ),
          },
          {
            label: NotificationSettingsTypes.account.toUpperCase(),
            component: (
              <NotificationsAccount
                userId={userId}
                settingsData={settings?.data.filter(
                  (setting) =>
                    setting.notificationType ===
                    NotificationSettingsTypes.account,
                )}
                loading={loading}
                setPersonalSettings={setSettings}
              />
            ),
          },
        ];

  return (
    <div className="flex flex-col px-[16px] bg-bg-base">
      <div className="-mx-[16px]">
        <Switcher tabs={tabs} />
      </div>
    </div>
  );
};

export default NotificationSettingsSlider;
